import { reactive } from '@/core/reactive/reactive';
import { LoginConfig } from '@/core/config';
import { MyClient } from '@/core/reactive/services/sdk';

export const MyService = reactive.service(
  'my',
  MyClient,
)(Service => new Service(LoginConfig.current?.api?.host ?? ''));

export const MyServiceReactor = MyService.reactor('MyServiceReactor', {
  success: (response, services, db) => {
    const { payload, source } = response;
    switch (source) {
      case services.my.profile:
        db.users.clear();
        return db.users.add(payload);
      case services.my.updateProfile:
        return db.users.put(payload);
      case services.my.applications:
        db.applications.clear();
        return db.applications.bulkAdd(payload);
      case services.my.twoFactor:
        db.twofactor.clear();
        return payload ? db.twofactor.put(payload) : db;
      case services.my.removeTwoFactor:
        return payload.success ? db.twofactor.clear() : db;
      case services.my.clearCache:
        db.applications.clear();
        db.twofactor.clear();
        db.users.clear();
        return;
      default:
        return;
    }
  },
});

//Transform the array of callbacks to extract
//the application url, and then remove the callbacks
//property
/*
MyService.applications.interceptor('post', payload => {
  if (Array.isArray(payload)) {
    return payload.map(application => {
      application.applicationUrl = application.callbacks.find(x => x.callbackType === 5)?.url;
      delete application.callbacks;
      return application;
    });
  }

  return payload;
});
*/
